import React, { useState } from 'react';
import InfoSection from './InfoSection'; // Import the InfoSection component

const ChangeInfoConfirm = ({ orgName, onExpand }) => {
    const [changeInfoClicked, setChangeInfoClicked] = useState(false); // Change Info button state

    const buttonStyle = {
        display: 'block',
        width: '100%',
        padding: '10px',
        margin: '10px 0',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 'bold',
    };

    const changeInfoButtonStyle = {
        ...buttonStyle,
        backgroundColor: changeInfoClicked ? 'white' : '#343a40', // Invert color on click
        color: changeInfoClicked ? '#343a40' : 'white',
        border: `2px solid #343a40`, // Add a border
    };

    const confirmWindowStyle = {
        width: '100%',
        marginTop: '10px',
        padding: '15px',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
        border: `2px solid #343a40`, // Change Info outline color
        textAlign: 'center',
    };

    const textStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '10px',
    };

    const handleChangeInfoClick = () => {
        setChangeInfoClicked(!changeInfoClicked);
        onExpand(!changeInfoClicked); // Trigger modal expansion
    };

    const infoWrapperStyle = {
        display: 'flex',
        justifyContent: 'center', // Center the info sections horizontally
        flexWrap: 'wrap',
        gap: '20px', // Add spacing between info sections
    };

    return (
        <>
            <button style={changeInfoButtonStyle} onClick={handleChangeInfoClick}>
                Change Info
            </button>
            {changeInfoClicked && (
                <div style={confirmWindowStyle}>
                    <p style={textStyle}>Edit Info for {orgName}</p>
                    <div style={infoWrapperStyle}>
                        {/* Render 6 example info sections */}
                        {[...Array(4).keys()].map((i) => (
                            <InfoSection key={i} title={`Info Section ${i + 1}`} />
                        ))}
                    </div>
                    <div style={{ marginTop: '15px', textAlign: 'right' }}>
                        <button className="btn btn-success" style={{ marginRight: '10px' }}>Save</button>
                        <button className="btn btn-secondary" onClick={handleChangeInfoClick}>Cancel</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ChangeInfoConfirm;
